import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {RrspFormFactory} from './rrsp-form.factory';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {CalculationStore} from '../../../../../stores/calculation.store';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import {CalculationBaseForm} from '../../../base-form/form/base-form/calculation-base.form';
import {CalculationsUtils} from '../../../../../utils/calculations.utils';
import {AlertMessageStore} from '../../../../../../core/stores/alert-message.store';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import {CalculationKeynameEnum,} from '../../../../../../../../../../../common/src/enums/calculations/calculation-keyname.enum';
import {Subscription} from 'rxjs';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {ImportManager} from '../../../../../managers/import.manager';
import {FormChangeManager} from '../../../../../managers/form-change.manager';
import {CalculationLifecycleManager} from '../../../../../managers/calculation-lifecycle.manager';
import {ValidationGroupEnum} from '../../../../../../../../../../../common/src/enums/validation-group.enum';
import {EventManager} from '../../../../../../core/managers/event.manager';
import {DebugUtils} from '../../../../../../core/utils/debug.utils';
import {RrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/rrsp.options";
import {IncomeTaxPersonalInRrspOptions} from "../../../../../../../../../../../common/src/options/calculations/rrsp/income-tax/personal/income-tax-personal-in-rrsp.options";


@Component({
  selector: 'app-rrsp-form',
  templateUrl: './rrsp-form.component.html',
  styleUrls: ['./rrsp-form.component.scss'],
  standalone: false,
})
export class RrspFormComponent extends CalculationBaseForm<RrspOptions> implements OnInit, OnDestroy {

  calculationKeynameEnum = CalculationKeynameEnum;

  isExecuteButtonEnabled: boolean = false;

  onApplicabilityChangeSubscription: Subscription;

  constructor(public override readonly formFactory: RrspFormFactory,
              public readonly debugUtils: DebugUtils,
              calculationStore: CalculationStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              private readonly changeDetectorRef: ChangeDetectorRef,
              importManager: ImportManager,
              calculationLifecycleManager: CalculationLifecycleManager,
              formChangeManager: FormChangeManager,
              eventManager: EventManager,
  ) {
    super(
      formFactory,
      calculationStore,
      translateService,
      activatedRoute,
      modalService,
      router,
      optionsMapper,
      calculationsUtils,
      alertMessageStore,
      CalculationKeynameEnum.RrspSimulation,
      importManager,
      calculationLifecycleManager,
      formChangeManager,
      eventManager,
      [ValidationGroupEnum.Rrsp],
    );
    this.optionsType = RrspOptions;
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get personalIncomeForm(): AdvancedFormGroup<IncomeTaxPersonalInRrspOptions> {
    return this.form.formElements.personalIncomeTaxOptions as AdvancedFormGroup<IncomeTaxPersonalInRrspOptions>;
  }

  override ngOnInit(): void {
    super.ngOnInit();

  }

  override ngOnDestroy() {
    super.ngOnDestroy();

  }

  override refresh() {
  }
}
